import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

export const root = css`
  display: block;
  width: 100%;
  text-align: center;
  text-decoration: none;
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};

  img {
    display: block;
    margin-bottom: ${spacing.sm}px;
    width: 100%;
    height: 280px;
    object-fit: cover;

    ${mediaQuery(
      { min: minBreakpoints.M },
      css`
        margin-bottom: ${spacing.xl}px;
        height: 225px;
      `,
    )};
  }

  h3 {
    margin: 0 0 ${spacing.xs}px;
    ${responsiveText.HEADING.SM};
    font-weight: 400;
    color: var(--neutral-black-base);
  }

  strong {
    display: block;
    ${responsiveText.BODY.SM};
    font-weight: 600;
    color: var(--brand-purple-base);
    text-decoration: underline;
  }

  &:hover {
    img {
      filter: brightness(90%);
    }

    strong {
      text-decoration: none;
    }
  }
`;
